<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="auto"><h1>User Management</h1></v-col>
    </v-row>
    <v-row justify="center" align="center" v-if="fetchingUsers">
      <h2 class="d-block text-center">Loading</h2>
      <v-progress-linear v-if="fetchingUsers" label="Loading" indeterminate color="yellow" />
    </v-row>
    <v-row justify="center" align="center" v-if="Users">
      <v-col cols="auto" class="text-center"><h2>{{Users.totalCount}} Users, {{Users.items.length}} Loaded, Displaying {{filteredUsers.length}}</h2></v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="auto"><v-combobox :loading="!Topics" v-model="topicsToFilter" :items="Topics ? Topics.items : []" label="Filter by interests" multiple chips deletable-chips item-text="title" item-value="id" clearable /></v-col>
      <v-col cols="auto"><v-combobox :loading="!JobTitles" v-model="jobTitlesToFilter" :items="JobTitles ? JobTitles.items : []" label="Filter by Job title" multiple chips deletable-chips item-text="title" item-value="id" clearable /></v-col>
      <v-col cols="auto"><v-combobox :loading="!JobExperienceLevels" v-model="jobExperienceLevelsToFilter" :items="JobExperienceLevels ? JobExperienceLevels.items : []" label="Filter by Job Experience Level" multiple chips deletable-chips item-text="title" item-value="id" clearable /></v-col>
      <v-col cols="auto"><v-combobox :loading="!AgeBrackets" v-model="ageBracketsToFilter" :items="AgeBrackets ? AgeBrackets.items : []" label="Filter by Age Bracket" multiple chips deletable-chips item-text="title" item-value="id" clearable /></v-col>
      <v-col cols="auto"><v-checkbox v-model="newsletterFilter" label="Subscribed to newsletter" /></v-col>
      <v-col cols="auto"><v-checkbox v-model="tcFilter" label="Accepted terms and conditions" /></v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-data-table :headers="headers" :items="filteredUsers" :items-per-page="100" class="elevation-0">
          <template v-slot:[`item.jobTitle`]="{ item }">
           {{item.jobTitle ? item.jobTitle.title : ''}}
          </template>
          <template v-slot:[`item.ageBracket`]="{ item }">
           {{item.ageBracket ? item.ageBracket.title : ''}}
          </template>
          <template v-slot:[`item.jobExperienceLevel`]="{ item }">
           {{item.jobExperienceLevel ? item.jobExperienceLevel.title : ''}}
          </template>
          <template v-slot:[`item.emailSubscriptionState`]="{ item }">
           <v-checkbox disabled v-model="item.emailSubscriptionState" />
          </template>
          <template v-slot:[`item.topicsOfInterest`]="{ item }">
            <template v-if="item.topicsOfInterest">
              <v-chip small class="mx-1" v-for="topic in item.topicsOfInterest" :key="topic.id">{{topic.title}}</v-chip>
            </template>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="auto"><v-btn @click="download" depressed light>Download Spreadsheet</v-btn></v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListTopic from '@/graphql/ListTopic.gql'
import ListUser from '@/graphql/user-properties/ListUser.gql'
import ListAgeBracket from '@/graphql/user-properties/ListAgeBracket.gql'
import ListJobTitle from '@/graphql/user-properties/ListJobTitle.gql'
import ListJobExperienceLevel from '@/graphql/user-properties/ListJobExperienceLevel.gql'
import filter from 'lodash/filter'
import find from 'lodash/find'
import intersectionBy from 'lodash/intersectionBy'
import XLSX from 'xlsx'

export default {
  name: 'UserManagement',
  data () {
    return {
      newsletterFilter: false,
      fetchingUsers: true,
      tcFilter: true,
      topicsToFilter: [],
      jobTitlesToFilter: [],
      jobExperienceLevelsToFilter: [],
      ageBracketsToFilter: [],
      headers: [
        {
          text: 'Email',
          align: 'start',
          sortable: true,
          value: 'email'
        },
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Company',
          align: 'start',
          sortable: true,
          value: 'company'
        },
        {
          text: 'Job Title',
          align: 'start',
          sortable: true,
          value: 'jobTitle',
          sort: (a, b) => a.title.localeCompare(b.title)
        },
        {
          text: 'Experience',
          align: 'start',
          sortable: true,
          value: 'jobExperienceLevel',
          sort: (a, b) => a.title.localeCompare(b.title)
        },
        {
          text: 'Age',
          align: 'start',
          sortable: true,
          value: 'ageBracket',
          sort: (a, b) => a.title.localeCompare(b.title)
        },
        {
          text: 'Newsletter',
          align: 'start',
          sortable: true,
          value: 'emailSubscriptionState'
        },
        {
          text: 'Interests',
          align: 'center',
          sortable: true,
          value: 'topicsOfInterest',
          sort: (a, b) => a.length > b.length ? 1 : -1
        }
      ]
    }
  },
  methods: {
    download () {
      const users = JSON.parse(JSON.stringify(this.filteredUsers))
      users.forEach(user => {
        delete user.__typename
        this.Topics.items.forEach(topic => {
          user['interested-in-' + topic.title] = find(user.topicsOfInterest, { id: topic.id }) !== undefined
        })
        delete user.topicsOfInterest
        user.jobTitle = user.jobTitle ? user.jobTitle.title : ''
        user.jobExperienceLevel = user.jobExperienceLevel ? user.jobExperienceLevel.title : ''
        user.ageBracket = user.ageBracket ? user.ageBracket.title : ''
      })
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(users)
      XLSX.utils.book_append_sheet(wb, ws, 'users')

      XLSX.writeFile(wb, 'users.xlsx')
      // console.log(xlsx)
    }
  },
  computed: {
    filteredUsers () {
      if (this.Users) {
        return filter(this.Users.items, u => {
          let passedTopicFilter = this.topicsToFilter.length === 0
          if (!passedTopicFilter) {
            passedTopicFilter = intersectionBy(this.topicsToFilter, u.topicsOfInterest, 'id').length > 0
          }

          let passedJobTitleFilter = this.jobTitlesToFilter.length === 0
          if (!passedJobTitleFilter) {
            passedJobTitleFilter = intersectionBy(this.jobTitlesToFilter, [u.jobTitle], 'id').length > 0
          }

          let passedJobExperienceLevelFilter = this.jobExperienceLevelsToFilter.length === 0
          if (!passedJobExperienceLevelFilter) {
            passedJobExperienceLevelFilter = intersectionBy(this.jobExperienceLevelsToFilter, [u.jobExperienceLevel], 'id').length > 0
          }

          let passedAgeBraketFilter = this.ageBracketsToFilter.length === 0
          if (!passedAgeBraketFilter) {
            passedAgeBraketFilter = intersectionBy(this.ageBracketsToFilter, [u.ageBracket], 'id').length > 0
          }

          const passedNewsletterFilter = !this.newsletterFilter || (this.newsletterFilter && u.emailSubscriptionState)
          const passedTcFilter = !this.tcFilter || (this.tcFilter && u.acceptedTerms)

          return passedTopicFilter && passedNewsletterFilter && passedTcFilter && passedJobTitleFilter && passedAgeBraketFilter && passedJobExperienceLevelFilter
        })
      }
      return []
    }
  },
  apollo: {
    Users: {
      query: ListUser,
      variables () {
        return {
          limit: 100
        }
      },
      result (result) {
        if (result.data.Users.cursor) {
          this.$apollo.queries.Users.fetchMore({
            variables: {
              status: 'DRAFT',
              cursor: result.data.Users.cursor
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              return {
                Users: {
                  __typename: previousResult.Users.__typename,
                  items: [...previousResult.Users.items, ...fetchMoreResult.Users.items],
                  totalCount: previousResult.Users.totalCount,
                  cursor: fetchMoreResult.Users.cursor
                }
              }
            }
          })
        } else {
          this.fetchingUsers = false
        }
      }
    },
    Topics: {
      query: ListTopic,
      variables () {
        return {
          status: 'PUBLISHED'
        }
      }
    },
    AgeBrackets: {
      query: ListAgeBracket,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'years',
          descending: false
        }
      }
    },
    JobTitles: {
      query: ListJobTitle,
      variables () {
        return {
          status: 'PUBLISHED'
        }
      }
    },
    JobExperienceLevels: {
      query: ListJobExperienceLevel,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'prioriry',
          descending: false
        }
      }
    }
  }
}
</script>
